import markup from './passwordPattern.html';
import CommonApp from '../../app.js';
import {strings} from '../../../util/strings.js';
//import './passwordPatterns.scss';

var PasswordPatternController = function($scope, $sce, strings) {
    this.credentials = this.credentials || {};

    this.createPasswordTitle = strings.get('tdc_createPasswordTitle');

    this.passwordHintMessage = $sce.trustAsHtml(strings.get('tdc_passwordDisclaimerMessage'));

    this.passwordRule1 = strings.get('tdc_passwordRule1');
    this.passwordRule2 = strings.get('tdc_passwordRule2');
    this.passwordRule3 = strings.get('tdc_passwordRule3');
    this.passwordRule4 = strings.get('tdc_passwordRule4');

    this.changeImage = function() {
        if (this.credentials.passwordState === 'text') {
            this.credentials.passwordState ='password';
            this.showHideText = strings.get('tdc_pwd_show');
            this.showHideToolTip = strings.get('tdc_click_to_show_pwd');
        } else {
            this.credentials.passwordState = 'text';
            this.showHideText = strings.get('tdc_pwd_hide');
            this.showHideToolTip = strings.get('tdc_click_to_hide_pwd');
        }
    };

    this.analyzePassword = function(form) {
        if (this.credentials.userPassword == 'undefined'
                || this.credentials.userPassword == '') {
            form.$$parentForm.$setValidity('password', true);
            return true;
        }
        var password = this.credentials.userPassword;
        var strength = this.isSatisfied(password && password.length >= 8) &&
            (this.isSatisfied(password && /[\@\#\$\%\^\&\*\(\)\_\+\!]/.test(password)) +
            this.isSatisfied(password && /[a-z]/.test(password)) +
            this.isSatisfied(password && /[A-Z]/.test(password)) +
            this.isSatisfied(password && /[0-9]/.test(password)));
        this.credentials.isInvalidPassword = strength < 3;

        this.credentials.specialCharInPassword = this
            .isSatisfied(password && /[\@\#\$\%\^\&\*\(\)\_\+\!]/.test(password))===1;
        this.credentials.lowerCaseInPassword = this.isSatisfied(password && /[a-z]/.test(password))===1;
        this.credentials.upperCaseInPassword = this.isSatisfied(password && /[A-Z]/.test(password))===1;
        this.credentials.numberInPassword = this.isSatisfied(password && /[0-9]/.test(password))===1;
        this.credentials.numberOfConditions = this.isSatisfied(password && /[\@\#\$\%\^\&\*\(\)\_\+\!]/.test(password))
            + this.isSatisfied(password && /[a-z]/.test(password))
            + this.isSatisfied(password && /[A-Z]/.test(password))
            + this.isSatisfied(password && /[0-9]/.test(password));

        this.setFormValidity(form);
    };

    this.setFormValidity = function(form) {
        if (this.credentials.isInvalidPassword) {
            form.passwordInput.$setValidity('currentPasswordState', false);
            form.$$parentForm.$setValidity('password', false);
        } else {
            form.passwordInput.$setValidity('currentPasswordState', true);
            form.$$parentForm.$setValidity('password', true);
        }
    };

    this.isSatisfied = function(criteria) {
        return criteria ? 1 : 0;
    };

    this.init = function() {
        this.showHideToolTip = strings.get('tdc_click_to_hide_pwd');
        this.showHideText = strings.get('tdc_pwd_hide');
        this.credentials.passwordState = 'text';
    };
};

CommonApp.module.service('strings', function(){
    return strings;
});

PasswordPatternController.$inject = ['$scope', '$sce', 'strings'];

CommonApp.module.component('nsPasswordPattern', {
    template: markup,
    bindings: {
        credentials: '=',
        isSubmitted: '<'
    },
    controller: PasswordPatternController,
    controllerAs: 'ctrl'

});




//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/components/password-pattern/passwordPattern.js
// module id = 245
// module chunks = 0